import type { ExcelGridColumnHeaderControlProps } from "../models/excel-grid-component-props.models";
import { FunnelIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ExcelGridSortIcon } from "./ExcelGridSortIcon";

export const ExcelGridColumnHeaderControl = ({
  column,
  dataTest,
  filterValue,
  sortState,
  hasFilters,
  onClearFilters,
  onFilterChange,
  onSortToggle,
}: ExcelGridColumnHeaderControlProps) => {
  const sortDirection = sortState?.columnKey === column.key ? sortState.direction : null;
  const canFilter = column.filterable !== false;
  const canSort = column.sortable !== false;

  if (column.renderHeader) {
    return <>{column.renderHeader(column)}</>;
  }

  return (
    <div className="min-w-0">
      <div className="flex h-5 min-w-0 items-center gap-1">
        <button
          type="button"
          title={`Sort ${column.label}`}
          aria-label={`Sort ${column.label}`}
          disabled={!canSort}
          data-test={`${dataTest}-sort-${column.key}`}
          className="flex min-w-0 flex-1 items-center gap-1 text-left disabled:cursor-default disabled:opacity-60"
          onClick={() => canSort && onSortToggle(column)}
        >
          <span className="truncate">{column.label}</span>
          <ExcelGridSortIcon direction={sortDirection} />
        </button>
        {hasFilters && column.key === "ID" && (
          <button
            type="button"
            title="Clear filters"
            aria-label="Clear filters"
            data-test={`${dataTest}-clear-filters`}
            className="flex h-5 w-5 flex-none items-center justify-center text-[#4A5655] hover:text-green"
            onClick={onClearFilters}
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        )}
      </div>
      {canFilter && (
        <label className="mt-1 flex h-6 items-center gap-1 border border-[#D7E2DE] bg-white px-1 dark:border-gray-700 dark:bg-gray-800">
          <FunnelIcon className="h-3.5 w-3.5 flex-none opacity-60" />
          <input
            value={filterValue}
            aria-label={`Filter ${column.label}`}
            data-test={`${dataTest}-filter-${column.key}`}
            className="min-w-0 flex-1 select-text bg-transparent text-[11px] font-medium normal-case leading-5 text-gray-800 outline-none placeholder:text-gray-400 dark:text-gray-100"
            placeholder="Filter"
            onChange={(event) => onFilterChange(column.key, event.target.value)}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
            onDoubleClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => event.stopPropagation()}
          />
        </label>
      )}
    </div>
  );
};
